import React from 'react';
import { Box, Typography } from '@mui/material';
import { RedTheme } from 'common/global';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

let redtheme = RedTheme;
// any app specific constants that you don't want to keep in config can go here.
export const TapGlobalMessages = {
  dashboard: {
    NOT_FOUND_404: '404: page not found!',
  },
  themes: ['RedTheme', 'BlueTheme'],
  URLS: { ASK_GS: 'https://jnjgsportal.my.site.com/s/submit-request?' },
  LOA: {
    LOA_NO_DATA:
      'There is no data available because you are indicated as being on a leave of absence in SUMMIT.',
    ASK_GS_HELPER:
      'If this is incorrect and you are not on a leave of absence, please open a ticket with AskGS to request that your profile be updated to reflect your current leave status.',
    LOA_NO_DATA_MANAGER:
      'You can’t access your Performance Data as you are indicated as being on ‘Leave of Absence’ in SUMMIT.',
    ASK_GS_HELPER_MANAGER: 'Please open a ticket with AskGS to request update on your status.',
  },
  deleteAlertPopupMessages: {
    title: 'Confirm Deletion',
    message: 'Are you sure you want to delete the alert?',
    rightButtonText: 'Confirm',
    leftButtonText: 'Cancel',
  },
  columnHeaderTooltip: {
    jobDescriptionTooltip:
      'From EMERGE, latest manager review date for the Job Description (JD). If there is no value, the JD was not yet reviewed.',
    summaryOfExpTooltip:
      'From EMERGE, latest manager review date for the Summary of Experience (SOE). If there is no value, the SOE was not yet reviewed.',
    IndiviTrainingPlanTooltip:
      'From EMERGE, latest manager review date for the Individual Training Plan (ITP). If there is no value, the ITP was not yet reviewed.',
    completedOnTimeTooltip:
      'Completed on Time = total trainings completed on or before the due date / total trainings due for the past six (6) months.',
    completedOverallTooltip:
      'Completed Overall = total trainings completed (regardless of due date) / total trainings completed for current year plus past three (3) years.',
  },
  routeLabels: {
    myPerformance: 'My Performance',
    myTeamsPerformance: "My Team's Performance",
    trainingPlanView: 'Training Plan View',
    curriculumAssignmentRequest: 'Curriculum Assignment Request',
    adminView: 'Administrative View',
  },
  routePaths: {
    myPerformance: '/',
    myTeamsPerformance: '/TAP/myorganisation',
    trainingPlanView: '/TAP/trainingview',
    curriculumAssignmentRequest: '/TAP/curriculumAssignmentRequest',
    adminView: '/TAP/adminview',
  },
  adminQuickFilter: {
    dateRangePickerInfo: () => {
      return (
        <>
          <Box>
            {`Choose a date range to limit ‘Export Training Table’ based on training due date.`}
          </Box>
        </>
      );
    },
  },

  myPerformance: {
    statusOptionsList: [
      'Completed On Time',
      'Complete Overdue',
      'Incomplete',
      'Incomplete Overdue',
    ],
    myTrainingStatusDateRange: () => {
      return (
        <>
          <Box>
            The data is as per <Box sx={{ fontWeight: 'bold' }}>Training Due Date.</Box>
          </Box>
        </>
      );
    },
    completedOnTime:
      'Completed On Time = total trainings completed on or before the due date / total trainings completed',
    percentageCalculationHeader: 'Percentage Calculation',
    completedOverAll:
      'Completed Overall = total trainings completed (regardless of due date) / total trainings',
  },
  myTeamsPerformance: {
    statusOptionsList: ['Compliant', 'At Risk', 'Non-Compliant'],
    singleTeam: {
      searchByMangOrWWIDInfoTooltip: () => {
        return (
          <>
            <Box>
              {`User can search either by Username or by
                WWID based on their preference. For Example : If
                user types alphabets, the search feature will
                automatically start searching by Username and
                if user types numbers, the search feature
                will automatically start searching by WWID.`}
              <Box sx={{ marginTop: '5px' }}>
                <Typography component='span' sx={{ display: 'block', height: '15px' }}></Typography>
                <Typography component='span' sx={{ color: '#003479', fontWeight: 900 }}>
                  Please Note:{' '}
                </Typography>
                User cannot search both by Username and WWID simultaneously.
              </Box>
            </Box>
          </>
        );
      },
    },
    trainingsCompletedOnTimeTooltip:
      'Click the toggle to change the view from Trainings Completed on Time to Trainings Completed Overall.',
    trainingsCompletedOverAllTooltip:
      'Click the toggle to change the view from Trainings Completed Overall to Trainings Completed on Time.',
    statusMapper: (param) => {
      const statusMapper = [
        {
          title: 'Overdue Trainings',
          status: 'totalOverDue',
        },
      ];
      return statusMapper.filter((item) => item.status === param);
    },
    trainingsOverdueTooltipHeader: 'Calculation',
    trainingsOverdueTooltipBody: (
      <Box>
        This view shows all{' '}
        <Box component='span' sx={{ fontWeight: 'bold' }}>
          active
        </Box>{' '}
        training that is past the due date. Inactive training that was past due at the time of
        inactivation is not shown in this view.
      </Box>
    ),
    trainingsComingDueTooltipHeader: 'Calculation',
    trainingsComingDueTooltipBody: (
      <Box>
        <Box>
          Click &quot;
          <Box
            component='span'
            sx={{
              color: redtheme.palette.warning.main,
              fontFamily: '"J&J CircularTT Medium Web"',
              fontSize: '10px',
              fontWeight: 'bold',
            }}
          >
            SEE MORE
          </Box>
          &quot; to see currently assigned and actionable training coming due within the time period
          selected.
        </Box>

        <br />

        <Box>
          <Box component='span' sx={{ color: '#003479', fontWeight: 900 }}>
            Please Note:
          </Box>{' '}
          This list does not show training that has not yet been assigned within SUMMIT.
        </Box>
      </Box>
    ),
    percentageCalculationHeader: 'Percentage Calculation',
  },
  trainingPlanView: {
    breifDescription:
      'This view reflects all curricula currently assigned in order to be qualified to perform the duties of the position. Click on a curriculum title to view the training items within.',
    directReports: {
      searchByTMOrWWIDInfoTooltip: () => {
        return (
          <>
            <Box>
              {`User can search either by Team Member or by
                WWID based on their preference. For Example : If
                user types alphabets, the search feature will
                automatically start searching by Team Member and
                if user types numbers, the search feature
                will automatically start searching by WWID.`}
              <Box sx={{ marginTop: '5px' }}>
                <Typography component='span' sx={{ display: 'block', height: '15px' }}></Typography>
                <Typography component='span' sx={{ color: '#003479', fontWeight: 900 }}>
                  Please Note:{' '}
                </Typography>
                User cannot search both by Team Member and WWID simultaneously.
              </Box>
            </Box>
          </>
        );
      },
      downloadExcelToolTip: () => {
        return (
          <>
            <Box>
              {`Please note, the Excel output may contain more information than is displayed on the screen.`}
            </Box>
          </>
        );
      },
    },
  },
  disclaimertext: {
    myperdisclaimertext:
      'Job Description, Summary of Experience and Individual Training Plan data will only be coming from the EMERGE platform. When your information is in EMERGE, the data fields in TAP will be updated and reflected here.',
    myorgdisclaimertext:
      'Job Description, Summary of Experience and Individual Training Plan data will only be coming from the EMERGE platform. When the information for your team is in EMERGE, the data fields in TAP will be updated and reflected here.',
    admindisclaimertext:
      'Job Description, Summary of Experience and Individual Training Plan data will only be coming from the EMERGE platform. When your organisation information is in EMERGE, the data fields in TAP will be updated and reflected here.',
  },
  userGroupProfile: {
    subHeaderText:
      'Role profile enables individual users to view their role information and for people leaders to view and update the roles of their direct reports to ensure the assignment of appropriate role based curricula. This does not replace the use of any HR or training system used to on board or update employees or non-employees but to supplement that information and create a personalized experience for qualifying individuals for their job role.',
    disclaimer: `To add or change the role-based compliance curricula assigned to your direct report, click on their name, update the five (5) data elements, and select their role. Contact `,
    disclaimerNote: () => {
      return (
        <Typography component='span' sx={{ fontSize: '10px', display: 'block' }}>
          Note: Users whose information is pre-populated from 1-Supply
          <HelpOutlineIcon
            sx={{
              '&.MuiSvgIcon-root': {
                height: '10px',
                width: '10px',
                color: `${redtheme.palette.common.primaryMainBlue}`,
                marginTop: '2px',
                marginLeft: '2px',
              },
            }}
          />
          are read-only and are updated in 1-Supply.
        </Typography>
      );
    },
    myProfile: {
      basicInfoLabel: 'Basic profile information and details',
      jobTittleLabel: 'Job Title:',
      workerTypeLabel: 'Worker Type:',
      partnerCompanyLabel: 'Partner Company:',
      countryLabel: 'Country:',
      sectorLabel: 'Sector:',
      onLeaveLabel: 'On Leave:',
      jobRoleDetailsLabel: 'Job Role Details',
      toolTip: {
        organization: '1-Supply = [Division]',
        function: '1-Supply = [Function Area]',
        subFunction: '1-Supply = [Department]',
        specialization: '1-Supply = [Resource Area]',
        subSpecialization: '1-Supply = [Resource Sub Area]',
        additionalInformation:
          'We need more information regarding your selections and might reach out to you. Please add the details in the Additional Information box.',
        MergeWWID: 'Merge old wwid',
        leaveOfAbsence: 'This date range defines start of leave date & expected return date.',
      },
    },
    popupConfirmationMessage:
      "Are you sure you want to save the changes to your Team Member's profile?",
    savedSuccessMessage: 'Saved Successfully.',
    myTeamProfile: {
      wwid: 'WWID/User Name',
      partnerCompany: 'Partner Company',
      workerType: 'Worker Type',
      search: 'Search',
      selected: 'Selected',
      toolTip: {
        organization: '1-Supply Division',
        function: '1-Supply Function Area',
        subFunction: '1-Supply Department',
        specialization: '1-Supply Resource Area',
        subSpecialization: '1-Supply Resource Sub Area',
        role: 'Resource Role',
        adhocRole: 'Resource Adhoc Role',
        workerType: 'Worker Type',
        oneSupplyUser:
          'User details come from 1-Supply. The information is prepopulated and read only.',
        downloadButton:
          'Please note, the excel output may contain more information than is displayed on the screen',
      },
      requiredCurriculaHeadingText: 'Required Curricula for Selected Role',
      requiredCurriculaCountText: 'curricula',
    },
    otherChoosenMessage: `Since you've selected "Other", please explain what is needed in the "Additional Information" field and our support team will reach out to assist you further.`,
    reuiredFieldValidationMessage: `Please fill the mandatory fields.`,
  },
  tapMaintenance: 'TAP under Maintenance!',
  unAuthorizedAccess: 'Unauthorized Access',
  siteWillBack: 'Site will be back soon',
  userNotFound: 'User not found',
  //used before going to expire
  sessionGoingToExpireInactivity:
    'Your session is going to expire in next 60 seconds due to inactivity!',
  userIdlePopupTitle: 'You have been idle!',
  extendButtonText: 'Extend Session',
  //used after expired
  sessionExpiredText:
    'To protect privacy and enhance security, the page you are trying to access is no longer available. You will be redirected to DTH',
  sessionExpiredTitle: 'Your Session has Expired',
  redirectButtonLabel: 'Redirect',
  overallComplianceProfileTitle: 'Overall Compliance Profile',
  myTeamsComplianceDonutLabelText: 'Overall Compliance </br> profile for my team',
  myOrgComplianceDonutLabelText: 'Overall Compliance </br> profile for my organisation',
  textFieldValidationMessage: 'Only Alphanumeric, hyphens and spaces are allowed',
  trainingRequestApiSuccessMessage: 'Request raised successfully',
  largeDownloadSuccessMsg:
    'The report is ready and an email will arrive shortly with a link to the report location where you can access and download.',
  largeDownloadStartMsg:
    'Record count is greater than 100K. You will receive an email with a link to access the report.',
  okText: 'OK',
  tokenExpiredText:
    'Your login has expired. You will be redirected to the Login screen. Please re-login to continue.',
  tokenExpiredHeading: 'Your login has expired!',
  includeHierarchyCaption: 'Include Hierarchy Traceability',
  hierarchyInfo:
    'Toggle to include extra columns of manager details in the export file allowing you to trace users reporting line under the selected leader/manager’s hierarchy.',
  clickToDownload: 'Please click here to download.',
  additionalFilterInfo:
    'Date Range & Training Title/code is applied only to Exported training data. It will not reflect in dashboard widgets. ',
  exisitngDelegateMsg:
    'Please select a different Delegate; this Delegate is already assigned to a Manager.',
};
